import {
  Stack,
  Text,
  Icon,
  Panel,
  PanelHeader,
  PanelTitle,
  PanelSection,
  InlineStack,
  StatusIndicator,
} from '@customerio/pluma-components/react';

import type { ServicesApiEnvHealthAlert } from '@/services/api/services-api';
import { SEVERITY_COLOR } from '../utils';

function isMessagingAlert(alert: ServicesApiEnvHealthAlert): boolean {
  const msg = alert.message.toLowerCase();
  return (
    msg.includes('message') ||
    msg.includes('campaign') ||
    msg.includes('broadcast') ||
    msg.includes('transactional') ||
    msg.includes('delivery') ||
    msg.includes('sending')
  );
}

interface MessagingTabContentProps {
  alerts: ServicesApiEnvHealthAlert[];
}

export function MessagingTabContent({ alerts }: MessagingTabContentProps) {
  const messagingAlerts = alerts.filter(isMessagingAlert);

  return (
    <Panel>
      <PanelHeader>
        <PanelTitle text="product-h4" color="subtle">
          <InlineStack gap="050" alignBlock="center">
            <Icon name="notifications" size="sm" color="bold" />
            Alerts
          </InlineStack>
        </PanelTitle>
      </PanelHeader>
      <PanelSection>
        {messagingAlerts.length > 0 ? (
          <Stack gap="150">
            {messagingAlerts.map((alert, i) => {
              return (
                <InlineStack key={i} gap="100" alignBlock="center">
                  <StatusIndicator color={SEVERITY_COLOR[alert.severity]} />
                  <Text size="s">{alert.message}</Text>
                </InlineStack>
              );
            })}
          </Stack>
        ) : (
          <InlineStack gap="100" alignBlock="center">
            <Icon name="check-circle" size="sm" color="success" />
            <Text size="s" color="subtle">
              No messaging alerts
            </Text>
          </InlineStack>
        )}
      </PanelSection>
    </Panel>
  );
}
